import React from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Headers from "../components/Headers";

const CategoryProducts = () => {
  const { slug } = useParams();
  const { products, categories } = useSelector((state) => state.home);

  // Find the selected category by slug
  const category = categories.find((c) => c.slug === slug);

  // Filter products that belong to the selected category
  const categoryProducts = products.filter(
    (product) => product.categorySlug === slug
  );

  return (
    <div className="w-[87%] mx-auto">
      <div className="text-center flex justify-center items-center flex-col text-4xl text-slate-600 font-bold relative pb-[45px]">
        <h2>{category?.name || "Category"} Products</h2>
        <div className="w-[100px] h-[4px] bg-[#fb00ea] mt-4"></div>
      </div>

      <div className="w-full grid grid-cols-4 md-lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-6">
        {categoryProducts.length > 0 ? (
          categoryProducts.map((product, i) => (
            <div
              key={i}
              className="border border-[#fb00ea] rounded-3xl group transition-all duration-500 hover:shadow-md hover:-mt-3"
            >
              <div className="relative overflow-hidden">
                <img
                  className="sm:w-full w-full h-[240px] rounded-t-3xl"
                  src={product.image}
                  alt={product.name}
                />
                <ul className="flex transition-all duration-700 -bottom-10 justify-center items-center gap-2 absolute w-full group-hover:bottom-3">
                  <Link
                    to={`/product/${product.slug}`}
                    className="w-[38px] h-[38px] cursor-pointer bg-white flex justify-center items-center rounded-full hover:bg-[#fb00ea] hover:text-white hover:rotate-[720deg] transition-all"
                  >
                    View
                  </Link>
                </ul>
              </div>
              <div className="py-3 text-slate-600 px-2">
                <h2>{product.name}</h2>
                <div className="flex justify-start items-center gap-3">
                  <span className="text-lg font-bold">${product.price}</span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>No products found for this category.</p>
        )}
      </div>
    </div>
  );
};

export default CategoryProducts;
